import React from 'react';

const PackageList = ({ startIndex, onHover, packageItems = [], selectedIndexes = [], onSelect }) => {
  return (
    <ul className="pack_ul">
      {packageItems.map((item, index) => {
        // 실제 인덱스 계산 (startIndex와 현재 index 합산)
        const actualIndex = startIndex + index;
        
        return (
          <li
            key={index}
            // 팝업에서 선택된 항목이거나 default_flag가 'Y'인 경우만 active
            className={`pack_li ${selectedIndexes.includes(actualIndex) ? 'active' : ''}`}
            onMouseEnter={() => onHover(actualIndex)}
            onMouseLeave={() => onHover(null)}
            // 클릭 시 선택 처리를 위한 상위 컴포넌트 함수 호출
            onClick={() => onSelect(actualIndex)}
          >
            <div className="imgBox_48">
              <div className="brand_img_sub">
                <img src={item.brand_goods_img} alt="brand_img" loading="lazy"/>
              </div>
              <div className="detail_img_sub">
                <img src={item.goods_image[0]} alt="detail_img" loading="lazy"/>
              </div>
            </div>
            <div>
              <p className="pack_name ellipsis_clamp">{item.package_goods_name}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default PackageList;